module.exports = __webpack_public_path__ + "static/media/profile.abfd94f0.jpg";